import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {LockScreenAuth, LogoutUser} from "../../redux/actions/Auth.Action";

export default function LockScreen() {
  const [password, setPassword] = useState();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.Auth.userData);
  return (
    <div className="row min-h-fullscreen center-vh p-20 m-0 bg-img login-bg">
      <div className="col-12">
        <div
          className="card card-shadowed px-50 py-30 w-400px mx-auto text-center b-5 border-info"
          style={{ maxWidth: "100%" }}
        >
          <div>
            <img
              className="avatar avatar-xxl"
              src={userData.userimage}
              alt={userData.username}
            />
            <br />
            <br />
            <h5 className="lead">{userData.username}</h5>
            <small>Enter your password to retrieve your session</small>
          </div>
          <div className="mt-3">
            <div className="form-group">
              <input
                type="password"
                className="form-control"
                onChange={(e) => setPassword(e.target.value)}
              />
              <label htmlFor="password">Password</label>
            </div>
            <br />
            <button
              className="btn btn-bold btn-block btn-info w-100"
              onClick={(e) =>
                dispatch(
                  LockScreenAuth(
                    userData.username,
                    password,
                    userData.company,
                    false
                  )
                )
              }
            >
              {" "}
              Unlock
            </button>
          </div>
        </div>
        <p className="text-center text-white fs-13 mt-20">
          You're not {userData.username}?{" "}
          <span
            className="text-primary fw-500"
            onClick={() => dispatch(LogoutUser())}
          >
            Sign in
          </span>
        </p>
      </div>
    </div>
  );
}
